// extracted by mini-css-extract-plugin
var _1 = "DeleteIcon__dSymbol--pHAC_";
var _2 = "DeleteIcon__delete--Fsa9f OfficeGeneral__centeredColumn--asLhi";
export { _1 as "dSymbol", _2 as "delete" }
